import { Component } from '@angular/core';

@Component({
  selector: 'transflo-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Scheduler';
}
